var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-wrap items-center justify-between"},[_c('vs-button',{staticClass:"mb-base item-self-justify-right",attrs:{"icon-pack":"feather","icon":"icon icon-file"},on:{"click":_vm.printInvoice}},[_vm._v("Print")])],1),_c('exam-preview',{attrs:{"exam_prop":_vm.exam,"edit_mood":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }